











































import {Vue, Component, Prop} from "vue-property-decorator";
import {Slide} from "./types/Slide";
import WelcomeClose from '../../assets/svg/welcome-close.svg';

@Component({
    components: { WelcomeClose }
})
export default class Welcome extends Vue {
    @Prop({default: () => []}) slides: Slide[];

    activeSlideIndex = 0;

    get slidesNumber() {
        return this.slides.length;
    }

    get isLastIndex() {
        return this.activeSlideIndex == this.slidesNumber - 1;
    }

    get currentSlide() {
        if (this.activeSlideIndex <= this.slidesNumber - 1) {
            return this.slides[this.activeSlideIndex]
        }
        return this.slides[0] ?? {};
    }

    moveIndex() {
        if (this.isLastIndex) {
            this.done();
        }
        else {
            this.activeSlideIndex++;
        }
    }

    setIndex(index: number) {
        this.activeSlideIndex = index;
    }

    done() {
        console.log('done');
        this.$emit('done');
    }
}
